import { cn } from "@/core/helpers/cn";

type Props = {
  progress: number;
  className?: string;
  classNameInnerLine?: string;
  classNameActiveLine?: string;
};

export default function FactionProgressLine({
  progress,
  className,
  classNameInnerLine,
  classNameActiveLine,
}: Props) {
  const value = progress || 0;

  return (
    <div className={cn("w-full h-2.5 p-0.5 border border-[#3A3A3A]/40 rounded-xl", className)}>
      <div className={cn("h-full rounded-xl bg-[#3A3A3A]/20", classNameInnerLine)}>
        <div
          className={cn(
            "h-full bg-gradient-accent",
            progress < 100 ? "rounded-l-xl" : "rounded-xl",
            classNameActiveLine,
          )}
          style={{ width: `${value}%` }}
        />
      </div>
    </div>
  );
}
